import List from "./pages/List";
import Wizard from "./pages/Wizard";

const routes = [
  {
    path: "*",
    element: List,
    permissions: ["JOB_MODULE"],
  },
  {
    path: ":id/*",
    element: Wizard,
    permissions: ["JOB_MODULE"],
  },
];

export default routes;
